import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"}
}
const _hoisted_3 = ["viewBox"]
const _hoisted_4 = ["xlink:href", "height", "width"]
const _hoisted_5 = ["points", "onClick"]
const _hoisted_6 = ["points", "onMouseover", "onMouseout", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ossPdf = _resolveComponent("ossPdf")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isPDF)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ossPdf, {
            documentId: _ctx.document.id
          }, null, 8, ["documentId"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.document)
            ? (_openBlock(), _createElementBlock("svg", {
                id: "svg-document-validation",
                xmlns: "http://www.w3.org/2000/svg",
                width: "100%",
                viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"},
                key: _ctx.showOCR
              }, [
                _createElementVNode("image", {
                  id: "svg-image-document-validation",
                  "xlink:href": _ctx.document.signedUrl,
                  x: "0",
                  y: "0",
                  height: `${_ctx.imageHeight}px`,
                  width: `${_ctx.imageWidth}px`
                }, null, 8, _hoisted_4),
                (!_ctx.showOCR)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.svgVariants, (variant, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variant.coordinates, (coord, index2) => {
                          return (_openBlock(), _createElementBlock("polygon", {
                            key: `coord-${_ctx.document.id}-${index}-${index2}`,
                            ref_for: true,
                            ref: `variants-${index}-${index2}`,
                            points: _ctx.getPoints(coord),
                            style: _normalizeStyle(
                                    variant.active
                                        ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                        : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                ),
                            onClick: _withModifiers(($event: any) => (
                                    variant.active
                                        ? ''
                                        : _ctx.showCorrespondingField(variant, index, index2)
                                ), ["stop"]),
                            class: _normalizeClass(variant.focus ? 'highlighted' : '')
                          }, null, 14, _hoisted_5))
                        }), 128))
                      ], 64))
                    }), 256))
                  : (_ctx.showOCR && _ctx.ocr && _ctx.ocr.sentences && _ctx.ocr.sentences.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.ocr.sentences, (sentence, sIndex) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentence.tokens, (token, tIndex) => {
                            return (_openBlock(), _createElementBlock("polygon", {
                              key: `sentence-${sIndex}-token-${tIndex}`,
                              ref_for: true,
                              ref: `sentence-${sIndex}-token-${tIndex}`,
                              points: _ctx.getTokenPoints(token),
                              style: _normalizeStyle(_ctx.getTokenStyle(token)),
                              onMouseover: ($event: any) => (token.high = true),
                              onMouseout: ($event: any) => (token.high = false),
                              onClick: _withModifiers(($event: any) => (_ctx.onClickToken(token)), ["stop"])
                            }, null, 44, _hoisted_6))
                          }), 128))
                        ], 64))
                      }), 256))
                    : _createCommentVNode("", true)
              ], 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]))
  ]))
}